<h1 mat-dialog-title data-testid="cms-dialog-title">{{ data.title }}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.message" data-testid="cms-dialog-content-text"></p>
</div>
<div mat-dialog-actions>
  <div class="flex-1"></div>
  <button mat-button mat-dialog-close data-testid="cms-dialog-cancel-btn">
    {{ data.cancelLabel ?? "Cancel" }}
  </button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true" data-testid="cms-dialog-yes-btn">
    {{ data.confirmLabel ?? "Yes" }}
  </button>
</div>
